import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useLocation, Outlet } from 'react-router-dom';
import { AiOutlineHome, AiOutlineLogout, AiOutlineUsergroupAdd } from 'react-icons/ai';
import { FiSettings, FiUsers } from 'react-icons/fi';
import { BiCategoryAlt } from 'react-icons/bi';
import { MdRestaurantMenu, MdOutlineRestaurant } from 'react-icons/md';
import { FaRegClock } from 'react-icons/fa'; // Import the clock icon

import { MdOutlineDashboard } from 'react-icons/md';
import { FaUserShield, FaMoneyBillWave } from 'react-icons/fa';
import { FaBuilding } from 'react-icons/fa'; // Font Awesome
import { FiBookOpen } from 'react-icons/fi';
import {GiHotMeal} from 'react-icons/gi';
import {GiFruitBowl} from 'react-icons/gi';






import OrgContext from '../context/OrgContext';

const Layout = () => {
    const { availableOrgs, setActiveOrg, activeOrg } = useContext(OrgContext); // Use context here
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const pageTitles = {
        '/dashboard': 'Dashboard',
        '/articles': 'Articles',
        '/categories': 'Menu Categories',
        '/products': 'Products',
        '/locations': 'Locations',
        '/menus': 'Menus',
        '/kitchen': 'Kitchen',
        '/display': 'Display',
        '/roles': 'Roles',
        '/orgs': 'Organizations',
        '/users': 'Users',
        '/orderstats': 'Sales',
        '/attendancestats': 'Timesheets',
        '/inventory': 'Inventory',

    };

    const currentTitle = pageTitles[location.pathname] || 'Le Chef';

    const hideDrop = location.pathname === '/orgs';


    const toggleMenu = (e) => {
        e.stopPropagation();
        setIsMenuOpen(prevState => !prevState);
    };

    const handleLogout = () => {
        sessionStorage.removeItem('token');
        navigate('/');
    };

    useEffect(() => {
    }, [availableOrgs, activeOrg]);

    const handleOrgSelect = (e) => {
        const orgID = e.target.value;
        console.log("SELECTED: " + orgID);

        const selectedOrg = availableOrgs.find(org => org._id === orgID);
        setActiveOrg(selectedOrg);
        sessionStorage.setItem("activeOrg", selectedOrg);
        console.log("orgID set: " + orgID);
    };

    return (
        <div className="flex h-screen bg-gray-900 text-white">
            {/* Left Side Navigation */}
            <aside
                style={{
                    zIndex: 9999,
                    transform: isMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
                    transition: 'transform 0.3s ease-in-out',
                }}
                className="fixed top-0 left-0 h-full w-64 bg-gray-800"
            >
                <div className="p-4 border-b border-gray-700">
                    <h3 className="text-xl text-golden font-bold">Menu</h3>
                </div>
                <nav className="p-4">
                    <ul>
                    <li className="mb-2">
                            <Link to={`/ops`} className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <MdOutlineDashboard className="mr-2 text-2xl" /> Operations
                            </Link>
                        </li> 
                        <li className="mb-2">
                            <Link to={`/account-details`} className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <AiOutlineHome className="mr-2 text-2xl" /> Account
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/roles" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <FaUserShield className="mr-2 text-2xl" /> Roles
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/orgs" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <FaBuilding className="mr-2 text-2xl" /> Organizations
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/users" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <AiOutlineUsergroupAdd className="mr-2 text-2xl" /> Users
                            </Link>
                        </li>

                        <li className="mb-2">
                            <Link to="/categories" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <BiCategoryAlt className="mr-2 text-2xl" /> Menu Categories
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/articles" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <GiFruitBowl className="mr-2 text-2xl" /> Articles
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/products" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <GiHotMeal className="mr-2 text-2xl" /> Products
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/menus" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <FiBookOpen className="mr-2 text-2xl" /> Menus
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/orderstats" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <FaMoneyBillWave className="mr-2 text-2xl" /> Sales
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/attendancestats" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <FaRegClock className="mr-2 text-2xl" /> Timesheets
                            </Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/inventory" className="text-golden hover:text-white flex items-center" onClick={toggleMenu}>
                                <AiOutlineUsergroupAdd className="mr-2 text-2xl" /> Inventory
                            </Link>
                        </li>
                    </ul>
                </nav>
            </aside>

            {/* Main Content Area */}
            <div className="flex flex-col w-full" onClick={() => setIsMenuOpen(false)}>
                {/* Navbar */}
                <header className="flex justify-between items-center bg-gray-800 p-4 shadow-lg">
                    <div className="flex items-center">
                        <button onClick={toggleMenu} className="text-white mr-4">
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
                            </svg>
                        </button>
                        <h1 className="text-2xl text-center text-golden">{currentTitle}</h1>
                    </div>
                    <div className="flex items-center space-x-4">
                        {!hideDrop && (
                            <select
                                value={activeOrg ? activeOrg._id : 'none'}
                                onChange={handleOrgSelect}
                                className="p-2 bg-gray-700 text-white rounded-lg"
                            >
                                {availableOrgs.map(org => (
                                    <option key={org._id} value={org._id}>{org.orgName || `Organization ${org.orgNr}`}</option>
                                ))}
                            </select>
                        )}
                        <button onClick={handleLogout} className="bg-red-600 px-3 py-2 rounded hover:bg-red-700">
                            <AiOutlineLogout className="text-2xl" />
                        </button>
                    </div>
                </header>

                {/* Main Content */}
                <main className="flex-grow p-8 overflow-auto">
                    <Outlet />
                </main>

                {/* Footer */}
                <footer className="bg-gray-800 p-4 text-center">
                    <p className="text-gray-400">© 2024 Le Chef. All rights reserved WHEN BYTES MATTER.</p>
                </footer>
            </div>
        </div>
    );
};

export default Layout;


